import { from, of } from 'rxjs'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { isActionOf, getType } from 'typesafe-actions'
import { toast } from 'react-toastify'
import {
  getHistoryRequest,
  getHistorySuccess,
  getHistoryFailure,
  cancelTransactionSuccess,
  transactionStatusUpdated,
} from '../actions'
import { RootEpic } from '../types'

export const getHistoryDataEpic: RootEpic = (action$, state$, { fetchHistoryData }) => {
  return action$.pipe(
    filter(isActionOf([getHistoryRequest, cancelTransactionSuccess, transactionStatusUpdated])),
    switchMap(({ type, payload }) =>
      from(
        fetchHistoryData({
          ...state$.value.history.filters,
          ...(type !== getType(transactionStatusUpdated) && payload),
          token: state$.value.app.authToken || '',
        }),
      ).pipe(
        map((response) => getHistorySuccess(response)),
        catchError((message) => {
          toast.error('Failed to fetch user history data.')
          return of(getHistoryFailure(message))
        }),
      ),
    ),
  )
}

export default [getHistoryDataEpic]
